<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img class="img-fluid" src="../assets/images/banner/products_banner.jpg" alt="banner" />
        <div class="banner-text">
          <h1>投稿專區</h1>
          <div class="banner-text-line"></div>
          <span>Submission</span>
        </div>
      </div>
    </div>
    <!-- 上方切換選單 -->
    <div class="contentContainer-noMove" :style="{ backgroundImage: 'url(' + BG + ')' }">
      <div class="content">
        <!-- 專題投稿列表 -->
        <div class="tab-content" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="list-magazine"
            role="tabpanel"
            aria-labelledby="list-magazine-list"
          >
            <div class="content-title">
              <h2>{{ planTitle }}</h2>
              <div class="bread">
                <router-link to="/">
                  <i class="fas fa-home fa-lg"></i>
                </router-link>
                <span>></span>
                投稿專區
              </div>
            </div>
            <div v-if="title === '投稿專區'" key="transition1">
              <div>
                <div class="contribution-content-form active">
                  <div class="content-contact">
                    <div class="content-contact-border">
                      <form class="submission_box active" ref="form">
                        <input type="hidden" name="Id" :value="guid" />
                        <div
                          class="input_span"
                          v-for="(item, index) in topicList"
                          :key="item.Title"
                        >
                          <span v-html="item.Title"></span>
                          <div class="fileArea">
                            <label :for="`file${index}`" style="font-size: 14px;">點我上傳</label>
                            <input
                              :id="`file${index}`"
                              ref="file"
                              type="file"
                              name="File"
                              @change="toInputValue($event, item, index)"
                            />
                            <div v-show="!item.fileName" style="font-size: 14px;">
                              ※檔案請小於2.0MB(file max to 2.0MB)
                            </div>
                            <div class="file_name" v-show="item.fileName">
                              <input
                                type="text"
                                :id="`forFile${index}`"
                                :value="item.fileName"
                                disabled
                                style="font-size: 14px;"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="contact-btnBlock">
                          <div class="item">
                            <div class="btn blue-btn islogin" @click="submit">
                              <a href="javascript:;">完成送出</a>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubmissionApi from '@/assets/api/submission';
import activityApi from '@/assets/api/activity';
import Common from '@/common';
import BG from '../assets/images/index_bg_big.png';

export default {
  name: 'Submission',
  data() {
    return {
      BG,
      title: '投稿專區',
      planTitle: '投稿專區',
      isPlan: true,
      fileType: '',
      Submission: false,
      listTitle: [
        {
          titleZh: '專題投稿',
          titleEn: 'Plan',
        },
        {
          titleZh: '錄取名單',
          titleEn: 'admission',
        },
      ],
      detail: {},
      admissionDetail: {},
      myFile: [],
      fileName: '',
      fullFileName: '',
      formData: {
        Name: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
        submitTitle: '',
      },
      submissionNumber: '',
      topicList: [],
      participantData: {},
      receiptData: {},
    };
  },
  methods: {
    getDetail(id) {
      const vm = this;
      SubmissionApi.getSubmissionDetail(id).then((res) => {
        if (res.status === 200) {
          if (vm.$route.params.admissionId) {
            vm.admissionDetail = res.data.Data;
            vm.planTitle = vm.admissionDetail.Title;
            // console.log('錄取名單', res);
          } else if (vm.$route.params.planId) {
            vm.detail = res.data.Data;
            vm.planTitle = vm.detail.Title;
            // console.log('投稿', res);
          }
        }
      });
    },
    getActivityInfo() {
      const vm = this;
      activityApi.checkActivity(vm.submissionNumber).then((res) => {
        if (res.status === 200) {
          vm.participantData = res.data.Data.participant;
          vm.receiptData = res.data.Data.receipt;
          vm.planTitle = vm.receiptData.items[0].Title;
          vm.getTopicList();
        } else {
          vm.$swal({
            icon: 'warning',
            text: res.data.Message,
            confirmButtonText: '確定',
          });
        }
      });
    },
    getTopicList() {
      const vm = this;
      activityApi.getTopic(vm.participantData.Id).then((res) => {
        if (res.status === 200) {
          vm.topicList = res.data.Data;
          if (vm.topicList.some((item) => item.FileUrl !== '')) {
            vm.topicList.forEach((el, index) => {
              const tmpIndex = el.FileUrl.lastIndexOf('/');
              const tmpName = el.FileUrl.substring(tmpIndex + 1, el.FileUrl.length);
              vm.$set(vm.topicList[index], 'fileName', tmpName || '');
            });
          }
        } else {
          vm.$swal({
            icon: 'warning',
            text: res.data.Message,
            confirmButtonText: '確定',
          });
        }
      });
    },
    // eslint-disable-next-line consistent-return
    toInputValue(e, item, index) {
      const vm = this;
      if (!vm.topicList[index].fileName) {
        vm.$set(vm.topicList[index], 'fileName', '');
      }
      if (e.target.files || e.dataTransfer.files) {
        const File = e.target.files || e.dataTransfer.files;
        if (File[0].size > 6000000) {
          vm.$swal({
            icon: 'warning',
            text: '檔案大小超過 6MB，請重新選擇檔案',
            confirmButtonText: '確定',
          });
          return false;
        }
        // eslint-disable-next-line prefer-destructuring
        vm.myFile = File[0];
        const tmpFileName = File[0].name.split('.');
        if (tmpFileName.length >= 2) {
          // eslint-disable-next-line prefer-destructuring
          vm.fileName = tmpFileName[0];
        } else {
          vm.fileName = File[0].name;
        }
        vm.fullFileName = File[0].name;
        vm.topicList[index].fileName = vm.fileName;

        // if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(vm.fileName)) {
        //   vm.$swal({
        //     icon: 'warning',
        //     text: '檔名請勿使用特殊符號或空格',
        //     confirmButtonText: '確定',
        //   }).then((data) => {
        //     if (data.value) {
        //       vm.topicList[index].fileName = '';
        //       vm.deleteFile();
        //     }
        //   });
        // } else {
        const formData = new FormData();
        formData.append('Filename', vm.fileName);
        formData.append('File', vm.myFile, vm.fullFileName);
        vm.$store.dispatch('updateLoading', true);
        const postData = {
          activityId: vm.participantData.ActivityId,
          participantId: vm.participantData.Id,
        };
        activityApi.uploadTopic(postData, formData).then((res) => {
          vm.$store.dispatch('updateLoading', false);
          if (res.status === 200) {
            vm.topicList[index].FileUrl = res.data.Data.SubmissionUrl;
            vm.$swal({
              allowOutsideClick: false,
              icon: 'success',
              title: '上傳成功!請繼續上傳其他檔案或送出已完成投稿。',
              confirmButtonText: '確定',
            });
          } else {
            vm.$swal({
              icon: 'error',
              text: res.data.Message,
              confirmButtonText: '確定',
            });
          }
        });
        // }
      }
    },
    deleteFile() {
      const vm = this;
      vm.myFile = [];
      vm.fileName = '';
      vm.fullFileName = '';
      vm.$refs.file.value = '';
    },
    // eslint-disable-next-line consistent-return
    // submit() {
    //   const vm = this;
    //   if (
    //     !vm.formData.Name
    //     || !vm.formData.Mobile
    //     || !vm.formData.Email
    //     || !vm.myFile
    //     || !vm.fileName
    //   ) {
    //     vm.$swal({
    //       icon: 'warning',
    //       text: '尚有欄位未填寫',
    //       confirmButtonText: '確定',
    //     });
    //     return false;
    //   }
    //   const formData = new FormData();
    //   // formData.append('Id', vm.guid);
    //   formData.append('Name', vm.formData.Name);
    //   formData.append('Mobile', vm.formData.Mobile);
    //   formData.append('Telephone', vm.formData.Mobile);
    //   formData.append('Email', vm.formData.Email);
    //   formData.append('Affiliation', vm.formData.Affiliation);
    //   formData.append('Position', vm.formData.Position);
    //   formData.append('Filename', vm.fileName);
    //   formData.append('File', vm.myFile, vm.fullFileName);
    //   // console.log(vm.myFile);
    //   // for (var pair of formData.entries()) {
    //   //   console.log(pair[0] + ", " + pair[1]);
    //   // }
    //   vm.$store.dispatch('updateLoading', true);

    //   // 測試用
    //   // vm.$swal({
    //   //   icon: 'success',
    //   //   text: '投稿成功!',
    //   //   confirmButtonText: '確定',
    //   // }).then(() => {
    //   //   vm.reset();
    //   // });

    //   // 正式用
    //   // eslint-disable-next-line no-undef
    //   SubmissionApi.postSubmissions(vm.$route.params.planId, formData).then(
    //     (res) => {
    //       // console.log(res);
    //       vm.$store.dispatch('updateLoading', false);
    //       if (res.status === 200) {
    //         vm.$swal({
    //           allowOutsideClick: false,
    //           icon: 'success',
    //           title: '投稿成功!',
    //           text: `您的投稿編號為： ${res.data.Message}`,
    //           confirmButtonText: '確定',
    //         });
    //         vm.reset();
    //         // const UrlString = window.location.href;
    //         // const Url = new URL(UrlString);
    //         // vm.submissionId = Url.searchParams.get('Id');
    //       } else {
    //         vm.$swal({
    //           icon: 'error',
    //           text: '投稿失敗，請檢查您所填寫欄位及上傳的檔案，或著稍後在試!',
    //           confirmButtonText: '確定',
    //         });
    //       }
    //     },
    //   );
    //   // vm.$refs.form.submit();
    // },
    submit() {
      const vm = this;
      const postData = {
        ActivityId: vm.participantData.ActivityId,
        ParticipantId: vm.participantData.Id,
        TopicList: vm.topicList,
      };
      const hasFile = postData.TopicList.some((item) => item.FileUrl);
      if (hasFile) {
        activityApi.updateSubmission(postData).then((res) => {
          if (res.status === 200) {
            vm.$swal({
              allowOutsideClick: false,
              icon: 'success',
              title: '完成投稿。',
              confirmButtonText: '確定',
            });
          } else {
            vm.$swal({
              icon: 'error',
              text: res.data.Message,
              confirmButtonText: '確定',
            });
          }
        });
      } else {
        vm.$swal({
          icon: 'error',
          text: '請至少上傳一個檔案',
          confirmButtonText: '確定',
        });
      }
    },
    reset() {
      const vm = this;
      vm.formData = {
        Name: '',
        Mobile: '',
        Email: '',
        Affiliation: '',
        Position: '',
      };
      vm.deleteFile();
    },
  },
  created() {
    // $('#collapseOne').collapse('hide');
    const vm = this;
    if (vm.$route.params.submissionId) {
      vm.submissionNumber = vm.$route.params.submissionId;
    }
    vm.getActivityInfo();
    vm.guid = Common.generateUUID();
  },
  computed: {
    fromPath() {
      return this.$store.getters.from;
    },
  },
};
</script>

<style lang="scss">
.magazine-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 420px) {
    justify-content: center;
  }
  &:after {
    content: "";
    flex: 0 0 30%;
    width: 33.33333%;
    max-width: 325px;
  }
}
.submission_box .input_span label {
  display: block;
  padding: 5px 24px;
  background-color: #f68e56;
  color: #fff;
  // border-radius: 5px;
  cursor: pointer;
}
.submission_box .input_span .note {
  letter-spacing: 2px;
  padding: 5.5px 0;
}
.submission_box .input_span input[type="file"] {
  display: none;
}
.file_name {
  display: flex;
  align-items: center;
  flex: 1;
}
.file_name input {
  flex: 1;
  /* margin-right: 10px; */
}
.file_name .delete {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.file_name .delete span:nth-child(1) {
  color: #f00;
  font-weight: 600;
  padding: 0 10px;
  font-size: 1.5rem;
  width: unset;
  text-align: unset;
  margin-right: unset;
}
.file_name .delete span:nth-child(2) {
  font-weight: 600;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: unset;
  text-align: unset;
  margin-right: unset;
}

.fileArea {
  display: flex;
  align-items: center;
  width: 100%;

  label {
    margin-bottom: 0;
  }
}
</style>

<style lang="scss" scoped>
.content-contact {
  padding: 30px 0;
  width: 100%;
}

.content-contact-border {
  padding: 25px 35px;
}

.contribution-content-form.active {
  height: auto;
}

.input_span {
  span {
    width: 100%;
    font-size: 14px;

    @media (max-width: 420px) {
      margin-right: 0;
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>
